import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/interface-lock-closed.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M208 80h-32V56a48 48 0 0 0-96 0v24H48a16 16 0 0 0-16 16v112a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16M96 56a32 32 0 0 1 64 0v24H96Zm112 152H48V96h160zm-68-56a12 12 0 1 1-12-12 12 12 0 0 1 12 12" }, null, -1)])]);
}
var interface_lock_closed_default = { render };
//#endregion
export { interface_lock_closed_default as default, render };

//# sourceMappingURL=interface-lock-closed.svg.js.map